<template>
  <div class="page" v-loading="listLoading">
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="售后单号:">
            <el-input v-model="searchData.orderAfterSaleNo" placeholder="售后单号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="子订单号:">
            <el-input v-model="searchData.orderNo" placeholder="子订单号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商:">
            <el-input v-model="searchData.supplierName" placeholder="请输入商品名称" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--        <el-form-item label="退款状态:">-->
      <!--          <el-select size="small" v-model="searchData.isReturn">-->
      <!--            <el-option :value=false label="未退款"></el-option>-->
      <!--            <el-option :value=true label="已退款"></el-option>-->
      <!--          </el-select>-->
      <!--        </el-form-item>-->
      <el-form-item>
        <div style="display: flex;">
          <el-button type="primary" @click="searchFun">查询</el-button>
          <el-button @click="resetFun">重置</el-button>
          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--      @selection-change="selectCurrentRow"-->
    <!--      <el-button @click="dialogCtpVisible1=true">开</el-button>-->
    <!--      <el-button @click="dialogCtpVisible1=false">关</el-button>-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%"
      border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="resellerName" label="订单信息" width="300">
        <template slot-scope="scope">
          <p><span>订单号：{{ scope.row.orderNo }}</span></p>
          <p><span>分销商：{{ scope.row.resellerName }}</span></p>
          <p><span>商品信息：
              {{ scope.row.order.orderItems[0] && scope.row.order.orderItems[0].productSkuName }}
            </span></p>
          <p>
            <span>外部订单号：{{ scope.row.outOrderAfterSaleNo }}</span>
          </p>
          <p><span>购买数量：{{ (scope.row.order.orderItems[0] && scope.row.order.orderItems[0].quantity) }}
              <!--                          {{// scope.row.order && scope.row.order.orderItems && scope.row.orderItems.productSkuName}}-->
            </span></p>
          <p><span>价格：{{ scope.row.order.orderItems[0] && scope.row.order.orderItems[0].unitPrice }}</span></p>
          <p><span>金额合计：{{
              (scope.row.order.orderItems[0] && scope.row.order.orderItems[0].quantity)
              * (scope.row.order.orderItems[0] && scope.row.order.orderItems[0].unitPrice)
          }}</span></p>
          <p><span>收货信息：{{ scope.row.order.receivingName }},
              {{ scope.row.order.receivingMobile }},
              {{ scope.row.order.receivingProviceName }},
              {{ scope.row.order.receivingCityName }},
              {{ scope.row.order.receivingDistrictName }},
              {{ scope.row.order.receivingStreetName }},
              <!--                          {{scope.row.order.receivingAddress}},-->
            </span></p>
          <p><span>商品供应商： {{ scope.row.sourceName }}</span></p>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="orderNo" label="类型" width="120" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="订单状态" width="120" align="center"></el-table-column> -->
      <el-table-column prop="afterSaleQuantity" label="申请退换货数量" align="center"></el-table-column>
      <el-table-column prop="afterSaleAmount" label="申请退换货金额" align="center"></el-table-column>
      <el-table-column prop="afterSaleName" label="售后人" align="center"></el-table-column>
      <el-table-column prop="afterSaleMobile" label="售后人联系电话" align="center"></el-table-column>
      <!--        <el-table-column label="退款状态" align="center">-->
      <!--          <template slot-scope="scope">-->
      <!--            <span v-if="scope.row.isReturn">已退款</span>-->
      <!--            <span v-else>未退款</span>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <el-table-column prop="orderAfterSaleNo" label="售后单号" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <!--            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
          <!--                       @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
          <!--            </el-button>-->
          <el-button v-if="isDetail" type="primary" size="mini" @click="refoundMoneyDetail(scope.row)">详情
          </el-button>
          <el-button v-if="(isRefound && scope.row.platformOrderType === 1 && scope.row.platformOrder) &&
          (isRefound && scope.row.platformAfterOrderType !== 1 && scope.row.platformAfterSaleOrderId === null)"
            type="primary" size="mini" @click="kplRefound(scope.row)">开普勒退款
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
    <el-dialog @close="clearData" title="开普勒申请售后" :visible.sync="dialogCtpVisible1" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="售后数量：">
          <el-input v-model.number="applyCtpForm.quantity"></el-input>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select clearable value-key="id" v-model="applyCtpForm.afsType" @change="changeAfsType">
            <el-option v-for="(item, index) in ctpAfterSaleType" :key="index" :value="item" :label="item.afsTypeName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后原因：">
          <el-select clearable value-key="id" v-model="applyCtpForm.applyReasonName" @change="changeCtpReason">
            <el-option v-for="(item, index) in ctpAfterSaleReason" :key="index" :value="item"
              :label="item.applyReasonName"></el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="问题描述图片：" v-if="applyCtpForm.questionPic">-->
        <el-form-item label="问题描述图片：">
          <draggable :list="PicInfoList" :group="{ sort: true, animation: 500 }">
            <div class="img_box" v-for="(item, index) in PicInfoList" :key="index">
              <p class="del_box" @click.stop="handleDelPic(index)">
                <img src="../../../assets/del-icon.png" alt />
              </p>
              <img :src="item" alt @click.stop="handleBigPic(item)" />
            </div>
            <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
              :on-change="handleBusinessPic" multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="是否收到货：">
          <el-radio-group v-model="applyCtpForm.isReceived" @change="changeIsReceived">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="取件方式：">
          <el-select clearable v-model="applyCtpForm.pickWareType">
            <el-option :value="4" label="上门取件"></el-option>
            <el-option :value="8" label="大家电上门取件"></el-option>
            <el-option :value="40" label="客户发货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货地区:">
          <!-- 省 -->
          <el-select v-model="provinceName" placeholder="请选择省" @change="handleProvince" style="width: 150px;"
            value-key="id">
            <el-option v-for="item in provinceList" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
          <!-- 市 -->
          <el-select value-key="id" v-model="cityName" placeholder="请选择市" @change="handleCity" style="width: 150px;">
            <el-option v-for="item in cityList" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
          <!-- 区 -->
          <el-select value-key="id" v-model="countyName" placeholder="请选择区" @change="handleArea" style="width: 150px;">
            <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
          <!-- 街道 -->
          <el-select v-model="townName" placeholder="请选择街道" @change="handleStreet" style="width: 150px;" value-key="id">
            <el-option v-for="item in streetList" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货地址：">
          <el-input v-model="applyCtpForm.address" style="width: 270px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitCtpAfterSale">提交</el-button>
      </div>
    </el-dialog>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogBigImgVisible">
      <img style="width:100%;" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!-- 取消开普勒售后 -->
    <el-dialog title="开普勒取消订单" @close="closeCancel" :visible.sync="dialogCtpVisible2" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="取消订单原因：">
          <el-select v-model="cancelCtpForm.cancelReason" @change="getReason">
            <el-option :key="index" :label="item.label" :value="item" v-for="(item, index) in cancelReasoning">

            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="cancelCtpAfterSale">取消订单</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar"
import {
  getQiniuToken,
  OrderAfterSaleGetAll,
  JDCtpGetIsCanApplyInfo,
  JDCtpCreateAfsApply,
  JDCtpGetApplyReason,
  JDCtpCancelOrder,
  AreaGetAll, // 获取所有的区域
  GetAreaTree, GetAllArea, OrderAfterSaleConfirm,
} from '../../../api/api'
import draggable from "vuedraggable";

export default {
  components: { Toolbar, draggable },
  name: "Index",
  data() {
    return {
      currentAfterSaleId: null,
      cancelReasoning: [
        {
          value: '1',
          label: '订单不能按预计时间送达'
        },
        {
          value: '2',
          label: '其他渠道价格更低'
        },
        {
          value: '3',
          label: '该商品降价了'
        },
        {
          value: '4',
          label: '不想买了'
        },
        {
          value: '5',
          label: '其他原因'
        },
        {
          value: '6',
          label: '操作有误（商品、地址等选错）'
        },
        {
          value: '7',
          label: '商品无货'
        },
        {
          value: '100',
          label: '其他'
        }
      ],
      cancelCtpForm: {
        cancelReasonCode: null,
        cancelReason: '',
      },
      provinceName: null,
      cityName: null,
      countyName: null,
      townName: null,
      provinceId: null,
      cityId: null,
      countyId: null,
      townId: null,
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      dialogBigImgVisible: false,
      dialogImageUrl: '',
      PicInfoList: [],
      // ctpAfterSaleReason: [{id: 10, applyReasonName: "kuahs"}, {id: 20, applyReasonName: "aixu"}],
      ctpAfterSaleReason: [],
      ctpAfterSaleType: [{ id: 10, afsTypeName: "退货" }, { id: 20, afsTypeName: "换货" }],
      applyCtpForm: {
        afsType: null,
        applyReasonId: null,
        applyReasonName: null,
        needUploadPic: null,
        quantity: null,
        questionPic: null,
        isReceived: false,
        pickWareType: null,
        address: '',
        reason: null,
        platformCode: null
      },
      dialogCtpVisible1: false,
      dialogCtpVisible2: false,
      listLoading: false,
      tableList: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      isDetail: false,
      isRefound: false,
      searchData: {
        skipCount: 0, //页码
        maxResultCount: 10, //页长
        OrderNo: null,
        OutOrderNo: null,
        AfterSaleType: 1,
        orderAfterSaleNo: '',
        supplierName: '',
        isReturn: null,
        AfterSaleStatus: 2,
      },
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      value: '',
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      console.log('this.buttonList_table----', this.buttonList_table);
      // "refoundMoneyDetail"
      // "kplRefound"
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'refoundMoneyDetail') {
          this.isDetail = true
        }
      })
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'kplRefound') {
          this.isRefound = true
        }
      })
    }
  },
  created() {
    this.getTableList();
    this.getQiniuToken();
    this.getProvinceList()
  },
  methods: {
    clearData() {
      this.applyCtpForm = {
        afsType: null,
        applyReasonId: null,
        applyReasonName: null,
        needUploadPic: null,
        quantity: null,
        questionPic: null,
        isReceived: false,
        pickWareType: null,
        address: '',
        reason: null,
        platformCode: null
      }
      this.PicInfoList = []
      this.provinceName = ''
      this.cityName = ''
      this.countyName = ''
      this.townName = ''
      this.provinceId = null
      this.cityId = null
      this.countyId = null
      this.townId = null
      this.ctpAfterSaleReason = []
    },
    // 取消售后单申请
    closeCancel() {
      this.dialogCtpVisible2 = false
      this.cancelCtpForm.cancelReasonCode = null;
      this.cancelCtpForm.cancelReason = '';
      this.currentAfterSaleId = null;
    },
    getReason(val) {
      console.log(val);
      this.cancelCtpForm.cancelReasonCode = val.value;
      this.cancelCtpForm.cancelReason = val.label;
    },
    cancelCtpAfterSale() {
      if (!this.cancelCtpForm.cancelReasonCode) {
        return this.$message.error('请选择售后取消原因！')
      }
      let params = {
        Id: this.currentAfterSaleId,
        cancelReasonCode: this.cancelCtpForm.cancelReasonCode,
        cancelReason: this.cancelCtpForm.cancelReason,
      }

      this.$confirm("确认取消订单吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        // console.log('params:', params);return;
        JDCtpCancelOrder(params).then(res => {
          console.log('-------------', res)
          if (res.data.result && res.data.result.success) {
            this.$message.success(res.data.result.message || '操作成功')
            this.getTableList()
            this.dialogCtpVisible2 = false;
            this.currentAfterSaleId = null;
          } else {
            // this.$message.error(res.data.error.message)
            this.$message.success(res.data.result.message)
            this.dialogCtpVisible2 = false
            this.cancelCtpForm.cancelReasonCode = null;
            this.cancelCtpForm.cancelReason = '';
            this.currentAfterSaleId = null;
          }
        })
      }).catch(() => {
        console.log('cancel')
        this.dialogCtpVisible2 = false
        this.cancelCtpForm.cancelReasonCode = null;
        this.cancelCtpForm.cancelReason = '';
        this.currentAfterSaleId = null;
      });
    },
    handleProvince(e) {
      console.log('e', e);
      let that = this;
      this.provinceName = e.label;
      this.cityName = null;
      this.countyName = null;
      this.townName = null;
      this.provinceId = e.Id;
      this.cityId = null;
      this.countyId = null;
      this.townId = null;
      this.getCityList(e.id);
    },
    getCityList(id) {
      let that = this;
      let params = {
        MaxLevel: 2,
        parentId: id ? id : that.provinceId,
      };
      GetAreaTree(params).then((res) => {
        console.log('cityList', res)
        // that.cityList = res.data.response.data;
        res.data.result.children.forEach(item => {
          item.id = item.data.Id;
          item.label = item.data.Name;
          item.ParentId = item.data.ParentId;
          delete item.data;
          delete item.children;
        })
        this.cityList = res.data.result.children;
        console.log('cityList', res.data.result.children);
      });
    },
    handleCity(e) {
      let that = this;
      this.cityName = e.label;
      this.countyName = null;
      this.townName = null;
      this.cityId = e.id;
      this.countyId = null;
      this.townId = null;
      this.getAreaList(e.id);
    },
    getAreaList(id) {
      let params = {
        MaxLevel: 3,
        parentId: id ? id : this.cityId,
      };
      GetAllArea(params).then((res) => {
        // console.log('areaList----', res);
        // this.areaTreeList = this.loopTree(res.data.result.children);
        // res.data.result.items.forEach(item=>{
        //   item.id = item.id;
        //   item.label = item.name;
        //   item.ParentId = item.data.ParentId;
        // })
        this.areaList = res.data.result.items;
        console.log('areaList----', res.data.result.items);
      });
    },
    handleArea(e) {
      let that = this;
      that.countyName = e.name;
      that.townName = null;
      that.countyId = e.id;
      that.townId = null;
      that.getStreetList(e.Id);
    },
    //获取街道
    getStreetList(id) {
      let that = this;
      let params = {
        areaLevel: 4,
        parentId: id ? id : that.countyId,
      };
      console.log('params', params)
      GetAllArea(params).then((res) => {
        console.log('街道', res);
        that.streetList = res.data.result.items;
      });
    },
    handleStreet(e) {
      let that = this;
      that.townName = e.name;
      that.townId = e.id;
    },
    changeIsReceived(val) {
      // if(val){

      // }
      this.getProvinceList()
    },
    getProvinceList() {
      let params = {
        MaxLevel: 1
      };
      GetAreaTree(params).then((res) => {
        // this.areaTreeList = this.loopTree(res.data.result.children);
        res.data.result.children.forEach(item => {
          item.id = item.data.Id;
          item.label = item.data.Name;
          item.ParentId = item.data.ParentId;
          delete item.data;
          delete item.children;
        })
        this.provinceList = res.data.result.children;
        console.log('province----', res.data.result.children);
      });
    },
    handleBusinessPic(file) {
      let that = this;

      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic;
          if (that.PicInfoList[0]) {
            itemPic = res
          } else {
            itemPic = res
          }
          that.PicInfoList.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    //获取七牛token
    getQiniuToken() {
      let that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleBigPic(src) {
      this.dialogBigImgVisible = true;
      this.dialogImageUrl = src;
    },
    handleDelPic(index) {
      let that = this;
      that.PicInfoList.splice(index, 1);
    },
    async changeCtpReason(val) {
      console.log('售后原因', val)
      this.applyCtpForm.applyReasonId = val.id
      this.applyCtpForm.applyReasonName = val.applyReasonName
      this.applyCtpForm.needUploadPic = val.needUploadPic
      // if (!val.NeedUploadPic) {
      //   this.PicInfoList = []
      // }
      // debugger
      // if(val.id !== this.applyCtpForm.applyReasonId){
      //   this.PicInfoList = []
      // }


    },
    async changeAfsType(val) {
      if (val) {
        console.log('val', val);
        this.applyCtpForm.afsType = val
        let result = await JDCtpGetApplyReason({ afsType: val.id });
        // this.ctpAfterSaleType = res.data.response.afsSupportedTypes; // 售后类型
        console.log('售后原因', result);
        if (result.data.result && result.data.result.success) {
          this.ctpAfterSaleReason = result.data.result.items
        } else {
          this.$message.error(result.data.error.message)
        }
      } else {
        console.log('error')
        this.ctpAfterSaleReason = []
      }

    },
    getJDCtpGetApplyReason(val) {
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afsType: val
      }
      JDCtpGetApplyReason(params).then(res => {
        if (res.data.success) {
          this.ctpAfterSaleReason = res.data.response.ApplyReason
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    submitCtpAfterSale() {//提交开普勒售后
      // if (!this.applyCtpForm.afsType) {
      //   return this.$message.error('请选择售后类型！')
      // }
      // if (!this.applyCtpForm.applyReasonId) {
      //   return this.$message.error('请选择售后申请问题！')
      // }
      // if (!this.applyCtpForm.quantity) {
      //   return this.$message.error('请选择售后申请数量！')
      // }
      let data = {
        provinceName: this.provinceName,
        cityName: this.cityName,
        countyName: this.countyName,
        townName: this.townName,
        address: this.applyCtpForm.address
      }
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afsType: this.applyCtpForm.afsType,
        applyReasonName: this.applyCtpForm.applyReasonName,
        applyReasonId: this.applyCtpForm.applyReasonId,
        quantity: this.applyCtpForm.quantity,
        isReceived: this.applyCtpForm.isReceived,
        questionPic: this.PicInfoList.join(',')
      }
      if (this.applyCtpForm.isReceived) {
        params.pickWareType = this.applyCtpForm.pickWareType
        params.address = data
      }
      // console.log(params, '请求参数')
      //
      // // return
      JDCtpCreateAfsApply(params).then(res => {
        if (res.data.result && res.data.result.success) {
          this.getTableList()
          this.dialogCtpVisible1 = false
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    // 可以售后 直接售后
    // 无法售后,  已申请,展示原因可修改,
    // 未申请无法发起售后， 填写无法售后原因

    async kplRefound(row) {

      this.currentAfterSaleId = row.id;
      console.log('开普勒退款', row);
      // 是否可以发起售后
      let res = await JDCtpGetIsCanApplyInfo({ id: row.id });
      if (res.data.result && res.data.result.success) {
        // 可发起京东售后  直接售后
        console.log('开普勒退款', res);
        // this.applyCtpForm.productName = row.productName;
        // this.applyCtpForm.platformCode = row.order && row.order.platformCode;
        this.dialogCtpVisible1 = true;
        // let ress = await JDCtpCreateAfsApply();
        // if (res.data.result.success) {
        //   // this.getAfterSaleOrderList()
        //   await this.getTableList();
        //   this.$message.success(ress.data.result.message);
        //   this.dialogCtpVisible1 = false
        // } else {
        //   this.$message.error(res.data.msg)
        // }
      } else {
        // // 不可发起售后, 查询售后原因
        // if (RegExp(/不可发起售后/).test(res.data.msg)) {
        //   this.dialogCtpVisible2 = true//取消售后的弹框
        // } else {
        //   this.$message.error(res.data.msg)
        // }

        // this.$message.error(res.data.result.message || '操作失败, 请重试')
        this.dialogCtpVisible2 = true//取消售后的弹框
        // let result = await JDCtpGetApplyReason();
        // // this.ctpAfterSaleType = res.data.response.afsSupportedTypes; // 售后类型
        // console.log('售后原因', result);
        // // 取消订单
        // let data = await JDCtpCancelOrder();
        // console.log('取消订单', data);
      }
    },
    refoundMoneyDetail(row) {
      // console.log('退款详情');
      this.$router.push(`/AfterSalesService/RefoundMoney/AfterSaleDetail?Id=${row.id}&orderId=${row.orderId}`)
    },
    async getTableList() {
      this.listLoading = true
      this.searchData.skipCount = (this.pageIndex - 1) * this.pageSize
      this.searchData.maxResultCount = this.pageSize
      OrderAfterSaleGetAll(this.searchData).then(res => {
        if (res.data.success) {
          console.log('表格数据', res);
          this.tableList = res.data.result.items
          this.total = res.data.result.totalCount
        } else {
          this.$message.error(res.data.error.message)
        }
        setTimeout(() => {
          this.listLoading = false
        }, 500)
      })
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    resetFun() {
      this.searchData = {
        skipCount: 0, //页码
        maxResultCount: 10, //页长
        OrderNo: null,
        OutOrderNo: null,
        AfterSaleType: 1,
        orderAfterSaleNo: '',
        supplierName: '',
        isReturn: null,
        AfterSaleStatus: 2,
      }
      this.getTableList();
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableList()
    },
  }
}
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.img-box .el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
}

.img-box .el_upload:hover {
  border-color: #409eff;
}

.img-box .el_upload:hover .mask {
  opacity: 1;
}

.img-box .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 150px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}

.img-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px !important;
  text-align: center;
}

.img-box .avatar {
  width: 150px;
  height: 150px;
}

.pic-info {
  width: 80px;
  height: 80px;
  margin: 5px;
  cursor: pointer;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
</style>


